<template>
    <div class="p-0">
        <div v-if="isFlagFeatureVisible">
            <div class="font-color-171717">
        
                <div style="width: 100%;background-size: cover; margin: auto;color: #fff">
                    <CCard class="bg-white b-20 m-3 p-20 mb-5" style="border:none;" v-if="isListBlog">
                        <div class="ml-3 mt-3 mr-3">
                            <CRow class="m-2">
                                <CCol sm="12" class="m-3">
                                    <div class="text-right mb-1">
                                        <CButton type="button" class="custom-border-purple text-white ml-3" @click="toggleAddBlog">
                                            <span class="ml-3 mr-3">{{ buttonBlog }}</span>
                                        </CButton>
                                    </div>
                                </CCol>
                            </CRow>
                        </div>
                        <CCol sm="12">
                            <h3 class="custom-40px-500 text-center mb-4">Flag</h3>
                        </CCol>
                        <template v-if="Busy == true">
                            <div class="container text-center">
                                <pulse-loader :loading="loading" :color="color" :size="size"></pulse-loader>
                            </div>
                        </template>
                    <CCol sm="12">
                    <CRow>
                    <CCol sm="10">
                        <CInput type="text" placeholder="Search..." v-model="searchQuery" @keyup.enter="filterList" />
                    </CCol>
                    <CCol sm="2" style="margin:-30px auto">
                        <label for="itemsPerPage" class="p-0">Items per page:</label>
                        <select v-model="itemsPerPage" id="itemsPerPage" class="form-control">
                        <option value="10">Show 10</option>
                        <option value="20">Show 20</option>
                        <option value="50">Show 50</option>
                        </select>
                    </CCol>
                    </CRow>
                    <template v-if="Busy == true">
                        <div class="container text-center">
                            <pulse-loader :loading="loading" :color="color" :size="size"></pulse-loader>
                        </div>
                    </template>
                    <CDataTable hover class="table-align-middle mb-0 font-color-171717" :items="filteredLists" :fields="fields" :items-per-page="itemsPerPage" :pagination="true">
                    
                        <template #Title="{ item }">
                            <td>
                                <img v-if="item.PictureUrl !== '' && item.PictureUrl !== null" :src="item.PictureUrl" width="50px" />
                                <img v-else src="../assets/img/defaultbanner.png" width="50px" />
                                <br />
                            </td>
                        </template>
                        <template #CountryName="{ item }">
                            <td>
                                <label class="custom-12px-500">{{ item.CountryName }}</label>
                            </td>
                        </template>

                        <template #CountryCurrency="{ item }">
                            <td>
                                <label class="custom-12px-500">{{ item.CountryCurrency }}</label>
                            </td>
                        </template>

                        <template #CountrySymbol="{ item }">
                            <td>
                                <label class="custom-12px-500">{{ item.CountrySymbol }}</label>
                            </td>
                        </template>


                        <template #Action="{ item }">
                            <td>
                                <div class="d-flex">
                                    <label class="custom-border-purple p-20 b-20 text-white mt-1" @click="OpenUpdate(item.Id)"><span class="mr-3 ml-3">Edit</span></label>
                                    <img src="../assets/img/delete.png" @click="OpenDeletes(item)" style="max-width:30px" class="ml-2">
                                </div>
                            </td>
                        </template>
                    </CDataTable>
                </CCol>
                </CCard>
                <CCard class="bg-white b-20 m-3 p-20 mb-5" style="border:none;" v-if="isAddBlog">
                    <div class="p-2 ml-3 mt-3 mr-3">
                        <CCol sm="12" class="m-3">
                            <div class="text-right mb-1">
                                <CButton type="button" class="custom-border-purple text-white ml-3" @click="toggleAddBlog">
                                    <span class="ml-3 mr-3">{{ buttonBlog }}</span>
                                </CButton>
                            </div>
                        </CCol>
                        <h3 class="custom-32px-500 text-center font-color-171717">Upload Your Blog</h3>
                        <CRow class="mt-3">
                            <CCol sm="12" class="m-2">
                                    <div class="m-3">
                                        <CRow>
                                            <CCol sm="12">
                                                <h4 class="custom-14px-500 font-inter font-black">Flag</h4>
                                                <CCard>
                                                    <div class="text-center m-5">  <label class="text-center m-0 font-inter">
                                                            <img src="../assets/img/upload.png" 
                                                            class="ShowImg"
                                                            style="max-width:50px; cursor:pointer" 
                                                            @change="onFileChangeThumbnail" />

                                                            <input type="file" 
                                                            id="thumbnail" 
                                                            ref="mythumbnail" 
                                                            style="display:none;" 
                                                            @change="onFileChangeThumbnail" /><br /><br />

                                                    <div id="preview">
                                                        <img style="max-width: 100%" v-if="urlThumbnail" :src="urlThumbnail" class="border-16px"/>
                                                    </div>
                                                    <br /><br />
                                                    <span class="font-color-6941C6">Click to upload</span> <span class="font-color-696969"><br />
                                                                SVG, PNG, JPG or GIF (max. 800x400px)</span></label>
                                                    </div>
                                                </CCard>
                                            </CCol>
                                            <CCol sm="12">
                                                <h4 class="custom-14px-500 font-inter font-black">Title</h4>
                                                <CInput type="text" v-model="Title"/>
                                            </CCol>
                                            <CCol sm="12">
                                                <h4 class="custom-14px-500 font-inter font-black"> Contents</h4>
                                                <tinymce
                                                    id="d1"
                                                    v-model="Content"
                                                    placeholder="Enter Your Content"
                                                    class="mb-2"
                                                ></tinymce>
                                            </CCol>
                                            <CCol sm="12">
                                                <div class="text-right">
                                                    <label class="text-danger mt-5 mr-5">Cancel</label>
                                                    <CButton class="custom-border-purple text-white"><span class="ml-2 mr-2" @click="InsertBlogs">Publish</span></CButton>
                                                </div>
                                            </CCol>
                                        </CRow>
                                    </div>
                            </CCol>
                        </CRow>
                    </div>
                </CCard>

                <CCard class="bg-white b-20 m-3 p-20 mb-5" style="border:none;" v-if="isUpdateBlog">
                    <div class="p-2 ml-3 mt-3 mr-3">
                        <CCol sm="12" class="m-3">
                            <div class="text-right mb-1">
                                <CButton type="button" class="custom-border-purple text-white ml-3" @click="toggleUpdateBlog">
                                    <span class="ml-3 mr-3">Back To Home</span>
                                </CButton>
                            </div>
                        </CCol>
                        <h3 class="custom-32px-500 text-center font-color-171717">Upload Your Blog</h3>
                        <CRow class="mt-3">
                            <CCol sm="12" class="m-2">
                                    <div class="m-3">
                                        <CRow >
                                            <CCol sm="12">
                                                <h4 class="custom-14px-500 font-inter font-black">Flag</h4>
                                                <CCard>
                                                    <div class="text-center m-5">  <label class="text-center m-0 font-inter">
                                                    

                                                <input type="file" 
                                                    id="editthumbnail" 
                                                    ref="editmythumbnail" 
                                                    style="display:none;" 
                                                    @change="onFileChangeThumbnailEdit" /><br /><br />

                                                    <div id="preview">
                                                <img style="max-width: 100%" v-if="urlThumbnailEdit" :src="urlThumbnailEdit" class="border-16px"/>
                                            </div>
                                            <div v-if="hideImg">
                                            <img v-if="filePathFlag != null" :src="filePathFlag" style="max-width: 100%;" class="border-16px"/>
                                <img v-else src="../assets/img/DEFAULTBLOG.png" class="border-16px"/>
                            </div>
                                <br />  <br />
        <span class="font-color-6941C6" @change="onFileChangeThumbnailEdit">Click to upload</span> <span class="font-color-696969"><br />
                                                                SVG, PNG, JPG or GIF (max. 800x400px)</span></label>
                                                    </div>
                                                </CCard>
                                            </CCol>
                                            <CCol sm="12">
                                                <h4 class="custom-14px-500 font-inter font-black">Title</h4>
                                                <CInput type="text" v-model="CountryNameEdit"/>
                                            </CCol>

                                            <CCol sm="12">
                                                <h4 class="custom-14px-500 font-inter font-black">CountrySymbol</h4>
                                                <CInput type="text" v-model="CountrySymbolEdit"/>
                                            </CCol>
                                            
                                            <CCol sm="12">
                                                <div class="text-right">
                                                    <label class="text-danger mt-5 mr-5">Cancel</label>
                                                    <CButton class="custom-border-purple text-white"><span class="ml-2 mr-2" @click="UpdateFlagImage">Update</span></CButton>
                                                </div>
                                            </CCol>


                                        </CRow>
                                    </div>

                            </CCol>
                        </CRow>
                    </div>
                </CCard>
                <br /><br /><br />
            </div>
        
            </div>
            <div v-if="isPopupSuccess" class="popup-all backdrop-all">
                <div class="popup-all1">
                    <!-- Popup content -->
                    <div class="text-center">
                        <img style="max-width: 300px" src="../assets/img/successPopup.png" />
                        <h3 class="custom-28px-500 font-color-171717 text-center mt-3">
                            Save Successfully
                        </h3>
                        <CButton class="custom-border-purple mt-4 text-white" @click="closeSuccess" style="width:100px"><span class="ml-2 mr-2">OK</span></CButton>
                    </div>
                </div>
            </div>
            <div v-if="isPopupDelete" class="popup-all backdrop-all">
                <div class="popup-all1">
                    <!-- Popup content -->
                    <div class="text-center">
                        <img style="max-width: 100px" src="../assets/img/Ellipsedelete.png" />
                        <h3 class="custom-18px text-center mt-3">
                            Are you sure want to delete <br /> {{ sessionTitle }} ?
                        </h3>
                        <div class="mt-4">
                            <label class="custom-grey-radius ml-2 font-color-171717 mr-4" @click="DeleteSession(sessionDelete)" style="width:100px">Yes</label>
                            <label class="custom-border-purple p-2 text-center mr-2 text-white" @click="CloseDelete()" style="width:100px">Cancel</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else>
            <div v-if="isPopupError">
                <div class="popup-all1">
                        <!-- Popup content -->
                        <div class="text-center">
                            <img style="max-width: 100px" src="../assets/img/error.png" />
                            <h3 class="custom-32px-500 text-center mt-3 font-color-171717">
                               Ooops!
                            </h3>
                            <h3 class="custom-18px text-center mt-3">
                                You don’t have permission to access this page. Please contact your administrator or check your account settings.
                            </h3>
                        </div>
        
                    </div>
            </div>
            <br /> <br /> <br />
        </div>
    </div>
</template>


<script>
import Vue from "vue";
import { Carousel3d, Slide } from "vue-carousel-3d";
import MarqueeText from "vue-marquee-text-component";
import _ from "lodash";
Vue.component("marquee-text", MarqueeText);
import AOS from "aos";
import "aos/dist/aos.css";

Vue.use(Carousel3d);

import backgroundUrl from "../assets/img/bg.png";
import backgroundUrl1 from "../assets/img/BgPeople.png";
import backgroundMap from "../assets/img/Map.png";

import Mainlayout from "../containers/AllHeader.vue";
import Footerlayout from "../containers/TheFooter.vue";
import backgroundUrNoArrow from "../assets/img/bgline.png";
import { CChartDoughnut } from '@coreui/vue-chartjs'
import { CChartBar } from '@coreui/vue-chartjs'
import ToggleCard from '../components/Toggle.vue';
import PulseLoader from "vue-spinner/src/PulseLoader.vue";
Vue.use(require("vue-moment"));
Vue.use(require("moment"));
var moment = require("moment");


export default {

    name: "Login",
    components: {
        Carousel3d,
        Slide,
        MarqueeText,
        Mainlayout,
        Footerlayout,
        CChartDoughnut,
        CChartBar,
        ToggleCard,
        PulseLoader

    },

    data() {
        return {
            backgroundUrl,
            backgroundUrl1,
            backgroundMap,
            backgroundUrNoArrow,

            currentPage: 1,
            itemsPerPage: 10,
            fields: [{
                    key: 'Title'
                },
                {
                    key: 'CountryName'
                },
                {
                    key: 'CountryCurrency'
                },
                {
                    key: 'CountrySymbol'
                },
                {
                    key: 'Action'
                },
            ],
            blogs: [],
            isAddBlog: false,
            searchQuery: "",
            Busy: false,
            loading: "",
            color: "",
            size: "",
            isListBlog: true,
            isPopupSuccess: false,
            thumbnail: [],
            urlThumbnail: null,

            editthumbnail: [],
            urlThumbnailEdit: null,
            Title: "",
            Content: "",
            ShowImg: true,
            detailBlog: [],
            isUpdateBlog: false,

            CountryNameEdit: '',
            CountrySymbolEdit: '',
            CountryCurrencyEdit: '',
            filePathFlag: '',
            blogId: 0,
            PublishStatus: false,
            hideImg: true,
            isPopupDelete: false,
            sessionDelete: "",
            sessionTitle: "",
            features:[],
            isPopupError: true


        }

    },
    async mounted() {
        try {
            const isAuth = await this.UserAuth();
            if (isAuth) {

                this.GetInfoUser();
                this.GetListCountries();
                this.getFeatures();

            } else {
                this.GoToLogin();
            }
        } catch (error) {
            console.error("Error during authentication:", error);
            // Handle the error here
        }

    },
    watch: {
        PublishStatus(newValue) {
            console.log("PublishStatus updated via watcher:", newValue);
        }
    },
    computed: {
        filteredLists() {
            const query = (this.searchQuery || '').toLowerCase().trim(); // Ensure searchQuery is a string

            const filtered = this.countries.filter(item => {
                const job = item.CountryName || ''; // Ensure item.job is a string
                const matchesQuery = query ? job.toLowerCase().includes(query) : true;

                return matchesQuery;
            });

            return filtered;
        },
        totalItems() {
            return this.filteredLists.length;
        },
        pagedList() {
            // Paginate the filtered list based on currentPage and itemsPerPage
            const startIndex = (this.currentPage - 1) * this.itemsPerPage;
            return this.filteredLists.slice(startIndex, startIndex + this.itemsPerPage);
        },
        startIndex() {
            return (this.currentPage - 1) * this.itemsPerPage + 1;
        },
        endIndex() {
            return Math.min(this.currentPage * this.itemsPerPage, this.totalItems);
        },
        buttonBlog() {
            return this.isAddBlog ? 'Back to Home' : 'Add Flag';
        },
        isFlagFeatureVisible(){            // Check if the user has access to the Blog feature in the "Page" group
            return Array.isArray(this.features) && this.features.filter(f => f.FeaturesGroup === "Page" && f.FeaturesType === "Flag" && f.IsVisible).length > 0;
        }


    },

    methods: {
        truncateText(text) {
            const maxLength = 200;
            if (text.length > maxLength) {
                return text.substring(0, maxLength) + '...';
            }
            return text;
        },
        async GetInfoUser() {
            try {
                const response = await this.$API.get(this.$LoginUserDetail, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.info = response.data;
                    console.log("userInfo", this.user);
                    if (response.status == 200 && this.info != null) {
                        this.Name = this.info.name;
                        this.FullName = this.info.name;
                        this.PhoneNumber = this.info.phone;
                        this.Email = this.info.email;
                        this.Country = this.info.country;
                        this.UserType = this.info.userType;
                        this.AboutUsCandidate = this.info.aboutUsCandidate;
                        this.UserId = this.info.id;
                        this.filePaths = this.info.filePath;
                    } else {
                        console.log(this.info.detail);
                    }

                } else {
                    // Handle non-200 status code
                    console.error("Failed to fetch user information:", response);
                }
            } catch (error) {
                console.error("Error fetching user information:", error);
                // Handle the error here
            }
        },
        triggerFileInput() {
            this.$refs.mythumbnail.click();
        },
        onFileChangeThumbnail(event) {
            this.ShowImg = false;
            const file = event.target.files[0];
            if (file) {
                // Handle the file (e.g., upload it or display a preview)
                this.urlThumbnail = URL.createObjectURL(file);
                this.thumbnail = this.$refs.mythumbnail.files;
                console.log(file);
            }
        },
        onFileChangeThumbnailEdit(event) {
            this.hideImg = false;
            const file = event.target.files[0];
            if (file) {
                // Handle the file (e.g., upload it or display a preview)
                this.urlThumbnailEdit = URL.createObjectURL(file);
                this.editthumbnail = this.$refs.editmythumbnail.files;
                console.log(file);
            }
        },
        async GetListCountries() {
            try {
                this.Busy = true;
                const response = await this.$API.get(this.$GetListCountries, {
                    withCredentials: true
                });
                if (response.status === 200) {
                    this.Busy = false;
                    this.countries = response.data;
                } else {
                    // Handle non-200 status code
                }
            } catch (error) {
                // Handle the error here
            }
        },
        InsertBlog() {
            const formData = new FormData();
            formData.append("countryId", this.countryId);

            formData.append("file", this.thumbnail[0]);


            return this.$API
                .post(this.$UploadFlag, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    this.info = response.data;
                    if (response.status == 200) {
                        this.isPopupSuccess = true;
                    } else console.log("Error Saving");
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        onFileChangeThumbnail(e) {
            const file = e.target.files[0];
            this.urlThumbnail = URL.createObjectURL(file);
            this.HandleFileInputThumbnail();
        },
        HandleFileInputThumbnail() {
            console.log(this.$refs.mythumbnail.files);
            this.thumbnail = this.$refs.mythumbnail.files;
            //this.SubmitFileApplicationDescription1();
        },
        OpenUpdate(id) {
            this.flagId = id;
            this.GetDetailCountry(id);
            this.isUpdateBlog = true;
            this.isListBlog = !this.isUpdateBlog;

        },
        async GetDetailCountry(id) {
            try {
                const response = await this.$API.get(`${this.$GetListCountriesById}?countryId=${id}`);
                if (response.status === 200) {
                    const data = response.data;
                    if (data && typeof data === "object") {
                        this.CountryNameEdit = data.CountryName;
                        this.CountrySymbolEdit = data.CountrySymbol;
                        this.filePathFlag = data.PictureUrl;
                    } else {
                        console.log("error1: No blog detail found in response data", data);
                    }
                } else {
                    console.log("error1: Response status not 200, status:", response.status);
                }
            } catch (error) {
                console.log("error2: ", error.message);
            }
        },
        toggleAddBlog() {
            this.isUpdateBlog = false;
            this.isAddBlog = !this.isAddBlog;
            this.isListBlog = !this.isAddBlog;

        },
        toggleUpdateBlog() {
            this.isUpdateBlog = !this.isUpdateBlog;
            this.isListBlog = !this.isUpdateBlog;
        },
        toggleHome() {
            this.$router.go(0);
            this.isListBlog = !this.isAddBlog;
        },
        UpdateBlog() {
            console.log("PublishStatus before update:", this.PublishStatus);

            const formData = new FormData();
            formData.append("blogPostId", this.blogId);
            formData.append("title", this.TitleBlog);
            formData.append("content", this.ContentsBlog);
            formData.append("isPublish", this.PublishStatus.toString()); // Convert to string

            console.log("PublishStatus to send:", this.PublishStatus.toString());

            this.$API
                .post(this.$UpdateBlog, formData, { withCredentials: true })
                .then((response) => {
                    if (response.data.status === 400) {
                        this.Loading = false;
                        this.Message = response.data.message;
                        this.Error = true;
                    }
                    if (response.status == 200) {
                        if (response.data.status !== 400) {
                            this.isPopupSuccess = true;
                            this.UpdateBlogImage();
                            this.getListBlog();

                        } else {
                            this.Loading = false;
                            this.Message = response.data.message;
                            this.Error = true;
                        }
                    } else {
                        this.Loading = false;
                        this.Error = true;
                        this.Message = response.data.message;
                    }
                })
                .catch((error) => {
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        UpdateFlagImage() {
            const formData = new FormData();
            formData.append("file", this.editthumbnail[0]);
            formData.append("countryId", this.flagId);


            return this.$API
                .post(this.$UploadFlag, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {
                    this.info = response.data;
                    if (response.status == 200) {
                        this.isPopupSuccess = true;
                    } else console.log("Error Saving");
                })
                .catch((error) => {
                    console.log(error);
                });
        },

        closeSuccess() {
            this.isPopupSuccess = false;
            this.toggleHome();
        },
        handleSwitchChange() {
            console.log("PublishStatus changed to:", this.PublishStatus);
        },
        OpenDelete(item) {
            this.sessionDelete = item.Id;
            this.sessionTitle = item.Title;
            this.isPopupDelete = true;
        },
        DeleteSession: function(blogId) {
            const formData = new FormData();

            formData.append("blogPostId", blogId);

            return this.$API
                .post(this.$DeleteBlogPost, formData, {
                    withCredentials: true,
                })
                .then((response) => {
                    if (response.status == 200) {
                        this.Busy = false;
                        this.isPopupDelete = false;
                        this.getListBlog();
                    } else {
                        this.Busy = false;
                    }
                })
                .catch((error) => {
                    this.Busy = false;
                    this.Loading = false;
                    this.Error = true;
                    this.Message = error.response.data.message;
                });
        },
        CloseDelete() {
            this.isPopupDelete = false;
        },
        async getFeatures() {
            try {
                const response = await this.$API.get(this.$GetFeatures, {
                    withCredentials: true,
                });
                if (response.status === 200) {
                    this.features = response.data;
                } else {
                    console.error(`Unexpected response status: ${response.status}`);
                }
            } catch (error) {
                console.error('Error fetching features:', error);
            }
        },



    }

};
</script>


